import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ConversaGestorStore, TrechoMensagemGestor, trechosDaMensagem} from './conversa-gestor.store';
import {ConviteWhatsappMiaGestor, MiaGestorService} from './mia-gestor.service';

/**
 * Simulador do canal real — a casca é a do testador da Mia V3, porque é assim
 * que o lojista vai ver a conversa no WhatsApp.
 *
 * Não é brinquedo: o que não se sustenta aqui, sem cartão rico nenhum, não se
 * sustenta no canal. Por isso o rótulo de botão é cortado nos 20 caracteres da
 * Cloud API na própria tela — o corte precisa aparecer aqui, não em produção.
 */
@Component({
  selector: 'app-simulador-mia-gestor',
  templateUrl: './simulador-mia-gestor.component.html',
  styleUrls: ['./simulador-mia-gestor.component.scss'],
  providers: [ConversaGestorStore],
})
export class SimuladorMiaGestorComponent implements OnInit {
  @ViewChild('corpoChat') corpoChat: ElementRef;
  @ViewChild('campoMensagem') campoMensagem: ElementRef;

  texto = '';
  /** trava a execução para ajustar prompt sem criar empresa de verdade */
  naoExecutarAcoes = true;
  confirmandoReinicio = false;
  folhaAprovacao = false;
  folhaRascunho = false;
  /** convite do canal real: link wa.me com token de uso único para o número do lojista */
  convite: ConviteWhatsappMiaGestor | null = null;
  gerandoConvite = false;
  erroConvite = '';
  /** campo, não getter: getter recriaria a lista a cada ciclo de detecção */
  resumoPorCategoria: Array<{nome: string; itens: number; bloqueios: number}> = [];

  sugestoes = [
    'Quero criar minha loja',
    'O que falta pra terminar?',
    'Já mandei o cardápio, e agora?',
    'Não quero delivery, só retirada',
  ];

  constructor(public conversa: ConversaGestorStore, private servico: MiaGestorService) {}

  gereConviteWhatsapp(): void {
    if (this.gerandoConvite) return;
    this.gerandoConvite = true;
    this.erroConvite = '';
    this.servico.crieConviteWhatsapp()
      .then(convite => { this.convite = convite; })
      .catch(erro => {
        this.erroConvite = erro && erro.error && erro.error.erro ? erro.error.erro : 'Não foi possível gerar o convite.';
      })
      .then(() => { this.gerandoConvite = false; });
  }

  ngOnInit(): void {
    this.conversa.inicie().then(() => this.roleAteOFim());
  }

  /** negrito de WhatsApp (*asterisco único*) renderizado como no canal real */
  partesDaMensagem(texto: string): TrechoMensagemGestor[] {
    return trechosDaMensagem(texto);
  }

  /** o WhatsApp corta o rótulo do botão em 20 caracteres — mostramos o corte */
  rotuloDeBotao(texto: string): string {
    return String(texto || '').slice(0, 20);
  }

  rotuloFoiCortado(texto: string): boolean {
    return String(texto || '').length > 20;
  }

  aoTeclar(evento: KeyboardEvent): void {
    if (evento.key !== 'Enter' || evento.shiftKey || (evento as any).isComposing) return;
    evento.preventDefault();
    this.envie();
  }

  envie(): void {
    const mensagem = this.texto;
    if (!mensagem.trim() || this.conversa.enviando) return;
    this.texto = '';
    this.roleAteOFim();
    this.conversa.envie(mensagem).then(() => {
      this.roleAteOFim();
      setTimeout(() => this.campoMensagem && this.campoMensagem.nativeElement.focus(), 0);
    });
  }

  envieSugestao(sugestao: string): void {
    this.texto = sugestao;
    this.envie();
  }

  selecioneArquivos(evento: Event): void {
    const entrada = evento.target as HTMLInputElement;
    const arquivos = entrada.files ? Array.from(entrada.files) : [];
    entrada.value = '';
    if (!arquivos.length) return;
    this.roleAteOFim();
    this.conversa.anexeEAnalise(arquivos).then(() => this.roleAteOFim());
  }

  abraAprovacao(): void {
    this.folhaAprovacao = true;
  }

  prepareImportacao(): void {
    this.conversa.prepareImportacao().then(() => this.roleAteOFim());
  }

  aprove(): void {
    if (this.naoExecutarAcoes) return;
    this.folhaAprovacao = false;
    this.conversa.aprove().then(() => this.roleAteOFim());
  }

  cancele(): void {
    this.folhaAprovacao = false;
    this.conversa.cancele().then(() => this.roleAteOFim());
  }

  recarregue(): void {
    this.conversa.recarregue().then(() => this.roleAteOFim());
  }

  reinicie(): void {
    this.confirmandoReinicio = false;
    this.folhaAprovacao = false;
    this.folhaRascunho = false;
    this.conversa.reinicie().then(() => this.roleAteOFim());
  }

  abraRascunho(): void {
    const rascunho = this.conversa.analiseCardapio && this.conversa.analiseCardapio.rascunho;
    this.resumoPorCategoria = !rascunho ? [] : rascunho.categorias.map((categoria: any) => ({
      nome: categoria.nome,
      itens: categoria.produtos.length,
      bloqueios: categoria.produtos
        .filter((produto: any) => this.conversa.produtoTemBloqueio(produto)).length,
    }));
    this.folhaRascunho = true;
  }

  private roleAteOFim(): void {
    setTimeout(() => {
      if (!this.corpoChat) return;
      const corpo = this.corpoChat.nativeElement;
      corpo.scrollTop = corpo.scrollHeight;
    }, 0);
  }
}
